
import { defineComponent } from '@nuxtjs/composition-api'

export default defineComponent({
  props: ['itemnumber', 'image'],
  setup() {
    const pageStr: string = 'pages.item'
    const itemUrl: string = process.browser ? window.location.href : ''

    const clipboardCopy = () => {
      if (process.browser) {
        const textArea = document.createElement('textarea')

        textArea.style.position = 'fixed'
        textArea.style.top = '0'
        textArea.style.left = '0'
        textArea.style.width = '2em'
        textArea.style.height = '2em'
        textArea.style.padding = '0'
        textArea.style.border = 'none'
        textArea.style.outline = 'none'
        textArea.style.boxShadow = 'none'
        textArea.style.background = 'transparent'
        textArea.value = window.location.href
        document.body.appendChild(textArea)
        textArea.select()
        try {
          document.execCommand('copy')
        } catch (err) {}
        document.body.removeChild(textArea)
      }
    }

    return { pageStr, itemUrl, clipboardCopy }
  },
})
